var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"check-box"},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.checked)?_c('CheckIcon',{staticClass:"check",attrs:{"circle":"","circleColor":_vm.color}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }